import { CommonGet, CommonPost } from "../../../utils/CommonFetch";


export default {
    saveProduct,
    getAll,
    editData
    // checkProductAssign

};

async function saveProduct(data){
    let product = {
        productID: 0,
        productCode: data.productCode,
        productName: data.productName.trim(),
        productDescription: data.productDescription.trim(),
        isActive: data.isActive,
        createdBy: 0,
        createdDate: new Date().toISOString(),
        modifiedBy: 0,
        modifiedDate: new Date().toISOString(),
    }
    const response = await CommonPost('/api/Product/SaveProduct', null, product);
    return response;
}

async function editData(data) {
    data.productName = data.productName.trim();
    data.modifiedDate = new Date().toISOString()
    const response = await CommonPost('/api/Product/UpdateProduct', null, data);
    return response;
}


async function getAll() {
   
    const response = await CommonGet('/api/Product/GetAllProducts', null);
    return response.data;
}

// async function checkProductAssign(productID) {
//     const response = await CommonGet('/api/OperationentityProductMapping/CheckProductAssignIsExist', 'productID=' + productID);
//     return response.data;
// }